<div class="section-title">
    {{ 'mimic-drawing.appearance' | translate }}
</div>
<div class="dropdown-group">
    <app-channel-select-input
        name="pumpDirection"
        label="mimic.setting.pump-setting.pump-direction"
        [value]="selectedPumpDirection"
        [itemList]="pumpDirectionItemList"
        [dark]="true"
        [isDisabled]="!userCanEdit"
        (inputChange)="onPumpDirectionChange($event)"></app-channel-select-input>
</div>
